import React, { useState, useEffect } from 'react'
import toast from 'react-hot-toast';
import { addAddress, deleteAddress, getAddress, getOrders, updateAddress } from '../../Services/ProfileServices';
import { useSelector } from 'react-redux';

const useMyAddress = () => {

    const { user } = useSelector((state) => state.user)

    console.log("user", user)

    const [selectedAddress, setSelectedAddress] = useState("");
    const [isAddnewAddress, setIsAddnewAddress] = useState(0);
    const [isLoading, setIsLoading] = useState("");
    const [addressLine1, setAddressLine1] = useState(user?.street)
    const [addressLine2, setAddressLine2] = useState(user?.street)
    const [city, setCity] = useState(user?.city)
    const [state, setState] = useState("")
    const [country, setCountry] = useState("")
    const [zip, setZip] = useState("")
    const [allAddress, setAllAddress] = useState([])
    const [allOrders, setAllOrders] = useState([])
    const [editAddress, setEditAddress] = useState(null);
    const [addressId, setAddressId] = useState();


    const hanldeAddressLine1 = (e) => { setAddressLine1(e.target.value) }
    const hanldeAddressLine2 = (e) => { setAddressLine2(e.target.value) }
    const hanldeCity = (e) => { setCity(e.target.value) }
    const hanldeState = (e) => { setState(e.target.value) }
    const hanldeCountry = (e) => { setCountry(e.target.value) }
    const hanldeZip = (e) => { setZip(e.target.value) }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)

        if (addressId) {
            const body = {
                first_name: user?.name,
                last_name: user?.last_name,
                email: user?.email,
                phone: user?.phone,
                country: country,
                state: state,
                city: city,
                street: addressLine1,
                post_code: zip,
                address: addressLine2,
                id: addressId
            }

            let response = await updateAddress(body)
            if (response.statusCode === 200) {
                toast?.success(response?.message)
                setIsLoading(false)
                handleGetAddress();
                setIsAddnewAddress(0)
                setAddressId("")
                setAddressLine1("")
                setAddressLine2("")
                setCity("")
                setState("")
                setCountry("")
                setZip("")
            } else if (response.statusCode === 401) {
                toast?.error(response?.errors)
                setIsLoading(false)
            } else {
                for (const [key, value] of Object.entries(response?.errors)) {
                    toast?.error(value)
                }
                setIsLoading(false)
            }
            setIsLoading(false)

        } else {
            const body = {
                first_name: user?.name,
                last_name: user?.last_name,
                email: user?.email,
                phone: user?.phone,
                country: country,
                state: state,
                city: city,
                street: addressLine1,
                post_code: zip,
                address: addressLine2,
            }

            let response = await addAddress(body)
            if (response.statusCode === 200) {
                toast?.success(response?.message)
                setIsLoading(false)
                handleGetAddress();
                setIsAddnewAddress(0)
            } else if (response.statusCode === 401) {
                toast?.error(response?.errors)
                setIsLoading(false)
            } else {
                for (const [key, value] of Object.entries(response?.errors)) {
                    toast?.error(value)
                }
                setIsLoading(false)
            }
            setIsLoading(false)
        }

    }

    const handleGetAddress = async () => {
        let response = await getAddress()
        if (response.statusCode === 200) {
            setAllAddress(response?.response?.data)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handleGetOrders = async () => {
        let response = await getOrders()
        if (response.statusCode === 200) {
            console.log("response===>", response)
            setAllOrders(response?.response?.data?.data)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }


    const handleDeleteAddress = async (id) => {
        setIsLoading(true)
        let response = await deleteAddress({ id })
        if (response.statusCode === 200) {
            setIsLoading(false)
            toast?.success(response?.message)
            handleGetAddress();
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)

    }


    useEffect(() => {
        handleGetAddress()
    }, [])
    useEffect(() => {
        handleGetOrders()
    }, [])

    const handleEditAddress = (item) => {
        setEditAddress(item)
        setIsAddnewAddress(1)
        setAddressId(item?.id)
        setAddressLine1(item?.address)
        setAddressLine2(item?.street)
        setCity(item?.city)
        setState(item?.state)
        setCountry(item?.country)
        setZip(item?.post_code)
    }

    return {
        selectedAddress,
        setSelectedAddress,
        isAddnewAddress,
        isLoading,
        allAddress,
        hanldeAddressLine1,
        hanldeAddressLine2,
        hanldeCity,
        hanldeState,
        hanldeCountry,
        hanldeZip,
        handleSubmit,
        handleDeleteAddress,
        setIsAddnewAddress,
        addressLine1,
        addressLine2,
        city,
        state,
        country,
        zip,
        allOrders,
        handleEditAddress
    }
}

export default useMyAddress